<template>
  <div>
      <menu-admin />
       
  </div>
</template>

<style scoped>
 
</style>

<script>
 
import MenuAdmin from "@/components/MenuAdmin.vue";

export default {
   components:{
       MenuAdmin
   }
   
}
</script>
 
